var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.829,
    height: 18.829,
    viewBox: "0 0 18.829 18.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.588,6.588,9.762.115a.588.588,0,0,0-.7,0L.24,6.588a.588.588,0,1,0,.7.949l.24-.176v9.778A1.694,1.694,0,0,0,2.868,18.83H15.96a1.694,1.694,0,0,0,1.692-1.692V7.36l.24.176a.588.588,0,0,0,.7-.949ZM9.414,14.123a.883.883,0,1,1,.883-.883A.884.884,0,0,1,9.414,14.123Zm2.08-2.719a.588.588,0,0,1-.832,0,1.766,1.766,0,0,0-2.5,0,.588.588,0,0,1-.832-.832,2.943,2.943,0,0,1,4.161,0A.588.588,0,0,1,11.495,11.4Zm1.456-1.456a.588.588,0,0,1-.832,0,3.824,3.824,0,0,0-5.408,0,.588.588,0,0,1-.832-.832,5,5,0,0,1,7.073,0A.588.588,0,0,1,12.951,9.948Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHome);
export default __webpack_public_path__ + "static/media/smart-home.92b4d156e23f7c3a742aca51e47adc0e.svg";
export { ForwardRef as ReactComponent };